import {format} from 'date-fns';
import {Box, Right, Text} from 'platform/foundation';

import {parseDate, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {SLOT_HEIGHT} from '../constants/slotHeight';

interface TimeSlotProps extends RequiredTestIdProps {
  hour: number;
  id?: string;
}

export function TimeSlot(props: TimeSlotProps) {
  const time = parseDate(new Date().setHours(props.hour, 0)); // eslint-disable-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible

  return (
    <Box
      id={props.id}
      padding={2}
      height={SLOT_HEIGHT}
      borderBottom="1px solid"
      borderColor="general.separator"
    >
      <Right align="flex-start">
        <Text data-testid={suffixTestId('timeSlot', props)} size="xSmall" color="secondary">
          {format(time, 'H:mm')}
        </Text>
      </Right>
    </Box>
  );
}
